import React, { useCallback } from 'react'
import { useApp } from '../../../context/AppProvider'
import { isEmpty } from '../../../services/common'

const CitiesSuggestions = ({ searchValue, data, setSearchValue }) => {
    const { setValueLocation, valueLocation } = useApp()

    const onClickSelectCity = useCallback(
        (city) => {
            setValueLocation({ city: city.label, insee: city.value })
            setSearchValue('')
        },
        [setValueLocation, setSearchValue]
    )

    return (
        <div
            className={`${searchValue.length > 0 && isEmpty(valueLocation) ? '__opened' : '__closed'} baseocom-cities-suggestions`}
        >
            <ul>
                {data?.map((city, index) => (
                    <li onClick={() => onClickSelectCity(city)} key={`item-${index}`}>
                        {city?.label || city?.message}
                    </li>
                ))}
            </ul>
        </div>
    )
}

export default CitiesSuggestions
